class StickyAddToCart extends HTMLElement {
    constructor() {
        super();


        this.layout_type = this.querySelector("sticky-add-to-cart-content").getAttribute("layout-type")


        this.drawerType = this.querySelector("[drawer-to-open]") ? this.querySelector("[drawer-to-open]").getAttribute("drawer-to-open") : "sticky-add-to-cart-drawer"


        this.variantList = this.querySelector("[sticky-add-to-cart-variants]");
        this.addToCartButton = this.querySelector("[add-to-cart-button]");

        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
        document.addEventListener(_EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._updateStickyAddToCartContentUnAvailable.bind(this));



    }



    _updateStickyAddToCartContent(e) {
        let content_list = e.detail.sticky_content
        content_list.forEach(element => {

            let stickyElement = element.querySelector("sticky-add-to-cart-content")
            if (stickyElement.getAttribute("layout-type") === this.layout_type) {
                this.querySelector("[sticky-add-to-cart-content]").innerHTML = element.innerHTML
            }
        });

    }

    _updateStickyAddToCartContentUnAvailable(e) {
        if (!this.variantList) return;
        this.variantList.textContent = e.detail.variantOptions.join(", ")
        this.togleAddToCartButton(false)
    }

    disconnectedCallback() {

        document.removeEventListener(_EVENT_HELPER.updateStickyAddToCartContent, this._updateStickyAddToCartContent.bind(this));
    }

    togleAddToCartButton(buttonEnabled) {
        if (this.addToCartButton) {
            if (buttonEnabled) {
                this.addToCartButton.removeAttribute("disabled")
            }
            else {
                if (!this.addToCartButton.classList.contains("sticky-icon-button")) {
                    this.addToCartButton.textContent = window.variantStrings.unavailable
                }
                this.addToCartButton.removeAttribute("form")
                this.addToCartButton.setAttribute("disabled", true);
            }
        }
    }


}
window.customElements.define('sticky-add-to-cart', StickyAddToCart);


class StickyAddToCartContent extends HTMLElement {
    constructor() {
        super();
        this.addToCartButton = this.querySelector("[add-to-cart-button]");
        this.buttonContainer = this.querySelector("[stikcy-add-to-cart-button-content]")
        this.addToCartButton?.addEventListener("click", (e) => {
            const form = document.getElementById(this.addToCartButton.getAttribute('form'));
            if (form && !form.checkValidity()) {
                HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hideDrawer, this, {
                    drawerType: 'sticky-add-to-cart',
                });
                setTimeout(() => {
                    const productForm = form.closest('product-form');
                    if (productForm && productForm.scrollToFirstInvalidField) {
                        productForm.scrollToFirstInvalidField();
                    }
                }, 400);
                return;
            }
            HELPER_UTIL.submitButtonState(this.addToCartButton).loadingState();
            HELPER_UTIL.dispatchCustomEvent('submit', form)

        })
        this._product_container = document.querySelector('[product-container]');
        this._drawerScrollToSection = document.querySelector("drawer-component [scroll-to-section]")
        this._scrollToSectionButton = this.querySelector("[scroll-to-section]")

        /* Modo âncora ("Escolher meu kit"): sem botão de add-to-cart, e o sticky
           some enquanto a seção alvo (suppress-anchor) está visível. */
        this._stickyRoot = this.closest('sticky-add-to-cart');
        const suppressAnchor = this._stickyRoot?.getAttribute('suppress-anchor');
        this._suppressTarget = suppressAnchor ? document.getElementById(suppressAnchor) : null;

        this.breakpoint = window.matchMedia('(min-width:768px)');
        document.addEventListener(_EVENT_HELPER.resetStickyAddTocartButton, (e) => {
            if (!this.addToCartButton) return;
            HELPER_UTIL.submitButtonState(this.addToCartButton).resetState(
                1000
            );
            HELPER_UTIL.submitButtonState(this.addToCartButton).disableState(
                false
            );
        })
        this._boundScrollHandler = this._scrollHandler.bind(this);
        this._boundScreenResize = this.screenResize.bind(this);
        document.addEventListener('scroll', this._boundScrollHandler, { passive: true });
        window.addEventListener('resize', this._boundScreenResize, { passive: true });
        if (window.visualViewport) {
            this._boundViewportSync = this._syncViewportOffset.bind(this);
            window.visualViewport.addEventListener('resize', this._boundViewportSync, { passive: true });
            window.visualViewport.addEventListener('scroll', this._boundViewportSync, { passive: true });
        }
        document.addEventListener(_EVENT_HELPER.triggerVariantAddToCartError, (e) => {
            this.componentState = this.closest("sticky-add-to-cart").getAttribute("aria-hidden")
            if (this.componentState === "false") {
                this._scrollToSection(e)
            }
        })
        this._scrollToSectionButton?.addEventListener("click", this._scrollToSection.bind(this))
        this._drawerScrollToSection && this._drawerScrollToSection.addEventListener("click", this._scrollToSection.bind(this))
        this.scrollTosection = this._scrollToSectionButton?.getAttribute("scroll-to-section") || this._drawerScrollToSection?.getAttribute("scroll-to-section");
        this.scrollTosectionElement = document.querySelector(`#shopify-section-${this.scrollTosection} [variant-block]`)

    }
    connectedCallback() {
        /* Gatilho: o botão de compra da section (form em trigger-form). O sticky
           aparece assim que ele sai da tela por cima, descontando o header fixo.
           Sem botão visível (ex.: landing-hero esconde o submit), vale o fim do
           [product-container]. */
        const triggerForm = this._stickyRoot?.getAttribute('trigger-form');
        this._triggerButton = triggerForm ? document.getElementById(triggerForm)?.querySelector('[type="submit"]') : null;
        this._header = document.querySelector('[id^="shopify-section-"][id$="__header"]');
        this._product_containerOffsetTop = this._product_container.offsetTop;
        this._product_containerHeight = this._product_container.offsetHeight;
        this._totalScrollHeight = this._product_containerOffsetTop + this._product_containerHeight;
        this.screenResize();
        if (this._boundViewportSync) this._syncViewportOffset();
        if (this._suppressTarget && 'IntersectionObserver' in window) {
            this._suppressObserver = new IntersectionObserver(([entry]) => {
                this._stickyRoot.classList.toggle('suppressed', entry.isIntersecting);
            }, { threshold: 0.15 });
            this._suppressObserver.observe(this._suppressTarget);
        }
        this._scrollHandler();
    }

    _scrollToSection(e) {
        e.preventDefault()

        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.hideDrawer, this, {
            drawerType: this.drawerType,
        });
        this.scrollTosectionElementOffset > 0 &&
            window.scrollTo({
                top: this.scrollTosectionElementOffset,
                behavior: 'smooth'
            })
    }
    screenResize() {
        if (this._product_container) {
            this._totalScrollHeight = this._product_container.offsetTop + this._product_container.offsetHeight;
        }
        if (this.breakpoint.matches === true) {
            this.scrollTosectionElementOffset = this.scrollTosectionElement ? this.scrollTosectionElement?.offsetTop + this._product_container?.offsetTop : 0

        } else {
            this.scrollTosectionElementOffset = this.scrollTosectionElement ? document.querySelector("[scroll-product-info]")?.offsetTop + this.scrollTosectionElement?.offsetTop : 0
        }
    }
    /* Chrome iOS: ao recolher as barras do navegador o layout viewport fica
       defasado e a barra (bottom: 0) descola do fundo da tela; o excedente do
       viewport visual sobre o innerHeight é o gap a compensar. */
    _syncViewportOffset() {
        const vv = window.visualViewport;
        const gap = Math.round(vv.height + vv.offsetTop - window.innerHeight);
        this._stickyRoot.style.bottom = gap > 0 ? `-${gap}px` : '';
    }
    _scrollHandler() {
        let shouldBeActive;
        if (this._triggerButton && this._triggerButton.offsetParent !== null) {
            const headerBottom = this._header ? Math.max(0, this._header.getBoundingClientRect().bottom) : 0;
            shouldBeActive = this._triggerButton.getBoundingClientRect().bottom < headerBottom;
        } else {
            shouldBeActive = window.scrollY > this._totalScrollHeight;
        }
        if (shouldBeActive === this._isActive) return;
        this._isActive = shouldBeActive;
        this.closest("sticky-add-to-cart")?.classList.toggle("active", shouldBeActive)
        /* this will toggle a class on the body to make the Announcement popup button visible */
        document.body.classList.toggle("sticky-add-to-cart-active", shouldBeActive)
    }

    disconnectedCallback() {
        this._suppressObserver?.disconnect();
        document.removeEventListener('scroll', this._boundScrollHandler);
        window.removeEventListener('resize', this._boundScreenResize);
        if (this._boundViewportSync) {
            window.visualViewport.removeEventListener('resize', this._boundViewportSync);
            window.visualViewport.removeEventListener('scroll', this._boundViewportSync);
        }
        this._scrollToSectionButton && this._scrollToSectionButton.removeEventListener("click", this._scrollToSection.bind(this))
        this._drawerScrollToSection && this._drawerScrollToSection.removeEventListener("click", this._scrollToSection.bind(this))
    }
}

window.customElements.define('sticky-add-to-cart-content', StickyAddToCartContent);